import { useAuth } from '@hooks/useAuth';
import { LoadingSpinner } from '@components/LoadingSpinner';

interface OptionalAuthRouteProps {
  children: React.ReactNode;
}

/**
 * OptionalAuthRoute - Allows access regardless of authentication status
 * Useful for pages that show different content based on auth state but don't require login
 */
export function OptionalAuthRoute({ children }: OptionalAuthRouteProps): JSX.Element {
  const { isLoading } = useAuth();

  // Show loading state while checking authentication (but don't block)
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return <>{children}</>;
}

